// extracted by mini-css-extract-plugin
export var home_page_notta_can_do_number = "index-module--home_page_notta_can_do_number--72a44";
export var home_page_pricing_feature_item_desc = "index-module--home_page_pricing_feature_item_desc--35467";